
var filter = {
	selectors: {
        filterLink: '[filter-type]',
	},
	init: function () {
		var self = this;

        if( jQuery( '[start-filter]' ).length > 0 && jQuery( '[start-filter]' ).attr( 'start-filter' ) != '' ) {
            var catSlug = jQuery( '[start-filter]' ).attr( 'start-filter' );
            // console.log( catSlug );

            self.filterFor( jQuery( '[start-filter]' ).attr( 'start-filter' ) );
            jQuery( 'a[filter-type="'+ catSlug +'"]' ).addClass( 'active' );
        }

        jQuery( document ).on('click', self.selectors.filterLink, function (event) {
            event.preventDefault();
            var catSlug = jQuery(this).attr( 'filter-type' );
            // console.log( catSlug );

            /* if( catSlug === 'none' ) {
                jQuery('[filter-type].active').removeClass( 'active' );


                return;
            } */

            if( jQuery(this).hasClass( 'active' ) ) {
                jQuery(this).removeClass( 'active' );

                jQuery( '.filter-hidden' ).removeClass( 'filter-hidden' );
                var newUrl = customVars.currentUrl;
            } else {
                jQuery( self.selectors.filterLink + '.active' ).removeClass( 'active' );
                jQuery(this).addClass( 'active' );

                if( catSlug !== 'none' ) {
                    self.filterFor( catSlug );
                    var newUrl = customVars.currentUrl + self.replaceQueryParam( 'type', catSlug, window.location.search );
                } else {
                    
                }
            }

            if( catSlug === 'none' ) {
                newUrl = customVars.currentUrl;
                self.removeHidden();
            }
            
            if( history.pushState  ) {
                history.pushState( {}, null, newUrl );
            }
        });
	},
    removeHidden: function() {
        jQuery( '.filter-hidden' ).removeClass( 'filter-hidden' );
    },
    filterFor: function( catSlug ) {
        var self = this;

        self.removeHidden();
        jQuery( "[class^='filter--'], [class*=' filter--']" ).each(function() {
            var searchClass = 'filter--' + catSlug;
            //console.log( search );

            if( ! jQuery(this).hasClass( searchClass ) ) {
                jQuery(this).addClass( 'filter-hidden' );
            }
        });
    },
    replaceQueryParam: function(param, newval, search) {
        var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
        var query = search.replace(regex, "$1").replace(/&$/, '');
    
        return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
    }
};

export { filter };
